// The panel writes with an id the backend hands out (a participant cannot pick one): its
// messages are the event talking, so they always carry the same name and badge
export const OFFICIAL_PREFIX = 'mod-';
export const OFFICIAL_NICKNAME = 'Bolivia Fitness';
export const isOfficial = (userId) => Boolean(userId?.startsWith(OFFICIAL_PREFIX));
